module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/aoj_d-1-e56002ab606fda67e613b29f91c345e6.jpg";